<template>
	<f7-views class="safe-areas main-views" ref="main-views">
		<f7-view
			class="loading-block-wrapper"
			v-if="!payment"
			:preload-previous-page="false"
			:ios-swipe-back="false"
			main
		>
			<LoaderBlock />
		</f7-view>
		<f7-view
			v-else
			main
			:url="getStartUrl(payment)"
			:preload-previous-page="false"
			:ios-swipe-back="false"
		/>

		<f7-view
			name="higher"
			url="/higher"
			:preload-previous-page="false"
			:ios-swipe-back="false"
		/>

		<hunting-agents-toast/>
	</f7-views>
</template>

<script setup lang="ts">
import HuntingAgentsToast from "@components/toasts/HuntingAgentsToast.vue";
import AppController from "@/targets/light/components/App/ts/AppController";
import LoaderBlock from "@components/atomic/loader-block/LoaderBlock.vue";
import {BuyingOperationStatus} from "@enums/BuyingOperationStatus";
import PurchaseOperation from "@models/operations/PurchaseOperation";

const appController = AppController.of();

const { paymentService } = appController;

const { payment } = paymentService;

const getStartUrl = (payment: PurchaseOperation) => {
	if (payment.status === BuyingOperationStatus.EMPTY) return '/create-payment';

	const allowedCompletionStatuses = [BuyingOperationStatus.CONFIRMED, BuyingOperationStatus.CANCELED];

	if (allowedCompletionStatuses.includes(payment.status as BuyingOperationStatus)) return  '/payment-to-up-complete';

	return '/payment';
}
</script>

<style scoped lang="scss">
.loading-block-wrapper {
	background-color: var(--white1);
}
</style>
